import { sign as signHandle } from '@/libs';
import { GlobalType } from '@/types/global';

export interface OProps {
  method: string;
  data?: any;
  headers?: Record<string, any>;
  hideErrTipsCode?: number[];
}

interface Request {
  <R = any>(url: string, options: OProps): Promise<R>;
}

const request: Request = async (reqUrl: string, options: OProps) => {
  const { method, data = {} } = options;
  let url = reqUrl;

  if (
    process.env.NODE_ENV === 'development' ||
    process.env.APP_ENV === 'local'
  ) {
    // 开发环境
    const prefix = process.env.BE_URL || '/api';
    const urlSuffix = reqUrl.startsWith('/') ? reqUrl : `/${reqUrl}`;
    url = `${prefix}${urlSuffix}`;
  } else {
    url = `${process.env.BE_URL}${reqUrl}`;
  }

  let requestConfig: any = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: method.toUpperCase(),
    credentials: 'include',
  };
  if (method?.toUpperCase() === 'GET') {
    const dataStr = Object.keys(data).reduce((previousValue, currentValue) => {
      return previousValue + `${currentValue}=${data[currentValue]}&`;
    }, '');

    const resultUrl = `${url}?${dataStr.substring(
      0,
      dataStr.lastIndexOf('&')
    )}`;
    const { datetime, sign } = signHandle(resultUrl, {
      method,
      data,
    });
    requestConfig.headers.sign = sign;
    requestConfig.headers.timestamp = datetime;
    url = resultUrl;
  }

  if (method?.toUpperCase() === 'POST') {
    if (options) {
      const serializeData: Record<string, any> = {};

      /**
       * 注：由于采取JSON.stringify, 所以须注意对象循环引用报错问题
       * */
      for (const key in data) {
        serializeData[key] = data[key];
      }
      // 签名 返回 随机数 和 签名
      const { datetime, sign } = signHandle(url, {
        method,
        data: {
          ...serializeData,
        },
      });
      const value: Record<string, string> = {
        // 业务数据
        ...serializeData,
      };
      requestConfig.headers.sign = sign;
      requestConfig.headers.timestamp = datetime;
      requestConfig.body = JSON.stringify(value);
    }
  }
  return new Promise(async (resolve, reject) => {
    try {
      // 请求超时设置
      const TIME_OUT_ID = setTimeout(() => {
        reject('请求超时');
        clearTimeout(TIME_OUT_ID);
      }, 30000);

      const response = await fetch(url, requestConfig);
      clearTimeout(TIME_OUT_ID);
      const type = response.headers.get('Content-Type');

      if (response.status < 200 || response.status >= 300) {
        // http状态码不在200-300之间
        reject({});
      }

      if (type?.includes('json')) {
        // 如果返回的是json
        const resJson: GlobalType.Result = await response.json();

        if (resJson.code > 0) {
          reject(resJson);
        }

        resolve(resJson.data);
      }
    } catch (err) {
      reject(err);
      console.log(err);
    }
  });
};

export { request };
